export default __webpack_public_path__ + "static/media/specialPurpodeDevelopment.dc87732b.jpg";